import script from "./BetslipSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./BetslipSettings.vue?vue&type=script&setup=true&lang=js"

import "./BetslipSettings.vue?vue&type=style&index=0&id=6de8e3e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6de8e3e6"]])

export default __exports__